import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '@df/catalog/product/product';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { Client } from '@df/core/service/client';
import { FacetUrlService } from '@df/module-facet-url/core/facet-url.service';
import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { Category, ICategoryDataV2 } from '@df/catalog/category/category';

/**
 * Generates hrefs for prerender to be used instead of js for FacetUrls
 * @see https://tomandco.atlassian.net/browse/OBR-2586
 */
@Pipe({
    name: 'facetUrl',
    standalone: true
})
export class FacetUrlPipe implements PipeTransform {
    /**
     * Dependencsies
     */
    constructor(
        private facetUrlService: FacetUrlService,
        private client: Client
    ) {}

    /**
     * Generates facetUrl if allowed by the rules described in OBR-2586
     * or undefined otherwise
     *
     * prerender only
     */
    transform(option: Catalog.IAttributeOption, filter: FilterAttributeOption<any>): string | undefined {
        // prerender only
        if (!this.client.isPrerender) {
            return;
        }

        // no likn when already selected
        if (filter.hasSelection) {
            return;
        }

        // check if that is category context
        const listing = filter.listing;
        const category = listing.config.source as Category<ICategoryDataV2>;

        if (category?.type !== Category.type) {
            return;
        }

        // check if its one of facet url attrs
        const attributeCode = filter.id;
        const attributeCodes = this.facetUrlService.getFacetAttributes(category, { [attributeCode]: option.label });
        if (!attributeCodes.includes(attributeCode)) {
            return;
        }

        // generate link
        return this.facetUrlService.createFacetUrl(category, { ...listing.prepareFiltersState(), [attributeCode]: option.label });
    }
}
